/** Maps a `Person` DB row — full contact record with address, phone, email, and document-signing responsibility level. */
export class Person {
  PERSID: number;
  PERSCLIID: number;
  PERSONDEPT: number;
  PERSONIDCODE: string;
  PERSONFNAME: string;
  PERSONMNAME: string;
  PERSONLNAME: string;
  PERSONPHONE: string;
  PERSONFAX: string;
  PERSONCPHONE: string;
  PERSONPHONE1: string;
  PERSONFAX1: string;
  PERSONNOTE: string;
  PERSONNOTE1: string;
  PERSONTITLE: string;
  PERSONCOUNTRY: string;
  PERSONCITY: string;
  PERSONADDR1: string;
  PERSONADDR2: string;
  PERSONEMAIL: string;
  PERSONINDEX: string;
  PERSPASSWORD: string;
  PERSSESSIONID: string;
  PERSSESSTIME: Date;
  PERSRESPONSIBLE: number;
  PERSRESPONSIBLESTR?: string;
  PERSSIGNID: number;
  cloneIndex?: number;

}

/** Lookup array mapping `PERSRESPONSIBLE` integer codes (−1 to 2) to their Ukrainian display labels. */
export const PersonResponcibilityList = [
  {
    index: -1, value: "Колишній співробітник"
  },
  {
    index: 0, value: "Нема"
  },
  {
    index: 1, value: "Може підписувати рахунки"
  },
  {
    index: 2, value: "Повне право підпису (Директор)"
  }
];

/*
    { name: 'Нема', value: 0 },
    { name: 'Може підписувати рахунки', value: 1 },
    { name: 'Повне право підпису (Директор)', value: 2 },*/

/*
SELECT [PERSID]
      ,[PERSCLIID]
      ,[PERSONDEPT]
      ,[PERSONIDCODE]
      ,[PERSONFNAME]
      ,[PERSONMNAME]
      ,[PERSONLNAME]
      ,[PERSONPHONE]
      ,[PERSONFAX]
      ,[PERSONCPHONE]
      ,[PERSONPHONE1]
      ,[PERSONFAX1]
      ,[PERSONNOTE]
      ,[PERSONNOTE1]
      ,[PERSONTITLE]
      ,[PERSONCOUNTRY]
      ,[PERSONCITY]
      ,[PERSONADDR1]
      ,[PERSONADDR2]
      ,[PERSONEMAIL]
      ,[PERSONINDEX]
      ,[PERSPASSWORD]
      ,[PERSSESSIONID]
      ,[PERSSESSTIME]
      ,[PERSRESPONSIBLE]
      ,[PERSSIGNID]
  FROM [dbo].[Person]
*/
